/*eslint-disable*/

import React from 'react'
import { IAnimal } from 'src/dto/animal.dto'
import { useStyles } from './styles'
import { Loading } from 'src/components'
import { useGetPregnancyDiagnosisListByAnimalId } from 'src/hooks/api/pregnancy-diagnosis'
import { ReproductiveCard } from 'src/components/ReproductiveCard'

interface IProductiveHistory {
  data?: IAnimal
}

export const ReproductiveHistory: React.FC<IProductiveHistory> = ({ data }) => {
  const styles = useStyles()
  const {
    data: historyList = [],
    isLoading,
    isFetching,
    isError,
    refetch
  } = useGetPregnancyDiagnosisListByAnimalId(data?.idAnimal!)

  if (isLoading || isFetching || isError) {
    return (
      <div className={styles.container}>
        <Loading isError={isError} refetch={refetch} />
      </div>
    )
  }

  if (!historyList || historyList.length === 0) {
    return <p style={{ color: '#000' }}>Nenhum registro de histórico reprodutivo encontrado.</p>
  }

  return (
    <div className={styles.container}>
      <div className={styles.cardList}>
        {historyList.map((historyItem) => (
          <ReproductiveCard key={historyItem.id} data={historyItem} />
        ))}
      </div>
    </div>
  )
}
